import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import gsap from 'gsap';
import './shop.css';
import shopBg from '../asserts/shop.mp4';
import Header from '../components/layout/Header';
import Btn4 from '../components/common/Btn4';
import Btn3 from '../components/common/Btn3';
import Preloader from '../components/layout/Preloader';

const DIALOGUE = `"Welcome, Shadow... will you trade a soul fragment today, or buy a new power?"`;

const Shop = () => {
  const navigate = useNavigate();
  const [showPreloader, setShowPreloader] = useState(true);
  const [displayed, setDisplayed] = useState('');
  const [doneTyping, setDoneTyping] = useState(false);

  const pageRef = useRef();
  const videoRef = useRef();
  const boxRef = useRef();
  const btnLeftRef = useRef();
  const btnRightRef = useRef();
  const typingRef = useRef(null);
  const indexRef = useRef(0);

  useEffect(() => {
    if (showPreloader) return;

    const video = videoRef.current;
    if (video) {
      video.playbackRate = 0.6;
    }

    gsap.set(boxRef.current, { opacity: 0, scale: 0.7, rotation: -6, transformOrigin: 'bottom left' });
    gsap.set(btnLeftRef.current, { opacity: 0, x: -60 });
    gsap.set(btnRightRef.current, { opacity: 0, x: 60 });

    const tl = gsap.timeline();

    tl.to(boxRef.current, {
      opacity: 1,
      scale: 1,
      rotation: 0,
      duration: 1.1,
      ease: 'back.out(1.6)',
      delay: 0.6,
    })
      .to(btnLeftRef.current, {
        opacity: 1,
        x: 0,
        duration: 0.7,
        ease: 'power3.out',
      }, '-=0.2')
      .to(btnRightRef.current, {
        opacity: 1,
        x: 0,
        duration: 0.7,
        ease: 'power3.out',
      }, '-=0.6');

    tl.call(() => startTyping());

    return () => {
      if (typingRef.current) clearTimeout(typingRef.current);
    };
  }, [showPreloader]);

  const startTyping = () => {
    indexRef.current = 0;
    setDisplayed('');
    setDoneTyping(false);
    typeNext();
  };

  const typeNext = () => {
    if (indexRef.current >= DIALOGUE.length) {
      setDoneTyping(true);
      return;
    }
    const i = indexRef.current;
    setDisplayed(DIALOGUE.slice(0, i + 1));
    indexRef.current += 1;
    typingRef.current = setTimeout(typeNext, 38);
  };

  const handleSkip = () => {
    if (!doneTyping) {
      if (typingRef.current) clearTimeout(typingRef.current);
      setDisplayed(DIALOGUE);
      indexRef.current = DIALOGUE.length;
      setDoneTyping(true);
    }
  };

  if (showPreloader) {
    return <Preloader onComplete={() => setShowPreloader(false)} />;
  }

  return (
    <div className="shop-page" ref={pageRef}>
      <video
        className="shop-video"
        ref={videoRef}
        src={shopBg}
        autoPlay
        loop
        muted
        playsInline
      />

      <Header />

<div className="shop-dialogue-box" ref={boxRef} onClick={handleSkip}>
  <div className="shop-dialogue-inner">
    <p className="shop-dialogue-text">
      {displayed}
      {!doneTyping && <span className="shop-cursor">|</span>}
    </p>
  </div>
  <div className="shop-hinge">
    <div className="shop-hinge-bar" />
    <div className="shop-hinge-bar" />
    <div className="shop-hinge-bar" />
  </div>
</div>
      <div className="shop-btn-left" ref={btnLeftRef}>
        <Btn3 onClick={() => navigate('/mainmenu')} />
      </div>

      <div className="shop-btn-right" ref={btnRightRef}>
        <Btn4 label="Buy" onClick={() => {}} />
      </div>
    </div>
  );
};

export default Shop;